import React, { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import toast from "react-hot-toast";
import imageSrc from "../images/newLogo.jpg";
import useAuthFetch from "../hooks/useAuthFetch";


const Login = () => {
  const [userName, setUserName] = useState();
  const [password, setPassword] = useState();
  const [isLoading, setIsLoading] = useState(false)

  const { login } = useContext(AuthContext);
  const customFetch = useAuthFetch()
  const navigate = useNavigate();

  const destroySession = async (userId) => {
    const url = new URL(`${process.env.REACT_APP_API_URL}/v1/dashboard/destroySession`);
    const method = "POST"
    const bodyContent = {
      userId
    }

    const { response, status, message } = await customFetch(
      url,
      method,
      bodyContent
    );

    if (status === 200) {
      handleLogin()
    }
  }

  const handleLogin = async (e) => {
    setIsLoading(true)
    e && e.preventDefault();

    try {

      const url = new URL(`${process.env.REACT_APP_API_URL}/v1/dashboard/login`);

      const bodyContent = {
        userName: userName,
        password: password,
        source: "VideoSDK",
      }

      const method = "POST"

      const { response, status, message } = await customFetch(
        url,
        method,
        bodyContent
      );

      if (status === 200) {
        login(response.user);
        if (response.user.role === "SUPPORT") {
          navigate('/dashboard/users', { state: { showToast: true } });
        } else {
          navigate('/dashboard/journeys', { state: { showToast: true } });
        }
      } else {
        if (response.message === "User is already logged in from another device/browser.") {

          toast.custom(
            (t) => (
              <div className="flex items-center justify-center text-[#363636] py-3 px-4 "
                style={{

                  lineHeight: '1.3',
                  willChange: 'transform',
                  boxShadow: '0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05)',
                  maxWidth: '350px',
                  pointerEvents: 'auto',
                }}
              >
                <div>
                  <p className="text-center">You're logged in on another device. Press OK to log out on that device and continue here, or Cancel to stay on the other device.</p>
                  <div className="flex items-center justify-center mt-3 ">
                    <button className=" bg-purple-300 rounded text-white py-2 px-3 cursor-pointer"
                      onClick={() => {
                        destroySession(response.userId)
                        toast.dismiss(t.id);
                      }}

                    >
                      OK
                    </button>
                    <button
                      className="ml-3 rounded text-white py-2 px-3 cursor-pointer bg-[#9e9e9e]"
                      onClick={() => {

                        toast.dismiss(t.id);
                      }}

                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            ),
            {
              duration: Infinity, // Keeps the toast open until manually dismissed
            }
          );


        }
        else {
          toast.error(message);
        }


      }
      setIsLoading(false)
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <main className="h-screen overflow-hidden">
      <div className="px-4 py-3">
        <img src={imageSrc} alt="ICICI Life Insurance" className="w-24 lg:w-32 w-auto rounded-lg object-contain" />
      </div>

      <div className="flex flex-1 h-full items-center justify-center">
        <div className="py-12 px-32 bg-white shadow-xl rounded-lg">
          <p className="text-black text-2xl font-extrabold mb-0 text-center">
            LOGIN
          </p>
          <div className="mt-14 flex flex-col">
            <div className="bg-[#F3F4F8] rounded-lg md:w-80 w-full p-4">
              <input
                value={userName}
                onChange={(e) => {
                  setUserName(e.target.value.trim());
                }}
                className="text-[#686E85] bg-[#F3F4F8] focus:outline-none w-full text-center"
                placeholder="Enter ntID"
              />
            </div>
            <div className="bg-[#F3F4F8] rounded-lg md:w-80 w-full p-4 mt-4">
              <input
                type="password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value.trim());
                }}
                className="text-[#686E85] bg-[#F3F4F8] focus:outline-none w-full text-center"
                placeholder="Enter Password"
              />
            </div>
            <div className="mt-4">
              <button
                onClick={async (e) => {
                  await handleLogin(e);
                }}
                className="bg-purple-300 py-4 w-full text-white text-base font-bold rounded-lg"
              >
                {isLoading ? "Authenticating User..." : "Login"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default Login;
